import React from 'react';
import { format, isToday } from 'date-fns';

import RoundButton from 'ck-core-client/source/ui/RoundButton';
import { FRIENDLY } from 'ck-core/source/data/DateFormat';
import { lang } from './lang';
import { MonetaryValue } from 'ck-core/source/classes/MonetaryValue';

export const UPDATE_DETAILS = Symbol('UPDATE_DETAILS');

interface Props {
	paymentDate?: Date;
	priceOrUpdateDetails: MonetaryValue | typeof UPDATE_DETAILS;
	// TODO: RoundButton takes a bunch of props and isn't in TS yet
	[key: string]: any;
}

export const PaymentButton: React.SFC<Props> = props => {
	const { paymentDate, priceOrUpdateDetails } = props;
	let text;

	if (priceOrUpdateDetails === UPDATE_DETAILS) {
		text = lang.UPDATE;
	} else {
		const price = priceOrUpdateDetails.format();

		text =
			paymentDate && !isToday(paymentDate)
				? lang.PRICE_ON_DATE(price, format(paymentDate, FRIENDLY))
				: lang.PRICE(price);
	}
	return (
		<div className="buttonWrapper">
			<RoundButton size="medium" colour="green" icon="secure-icon-white" text={text} {...props} />
		</div>
	);
};
